import { createSvgIcon, Grid } from '@mui/material';
import ServiceBox from './ServiceBox';
import AddressIcon from '@mui/icons-material/Home';
import GarbageIcon from '@mui/icons-material/Delete';
import YardIcon from '@mui/icons-material/Grass';
import BrushIcon from '@mui/icons-material/Park';
import CouncilIcon from '@mui/icons-material/AccountBox';
import SuperIcon from '@mui/icons-material/AccountBalance';
import FireIcon from '@mui/icons-material/LocalFireDepartment';

const RecyclingIcon = createSvgIcon(
  <path d='M5.77,7.15L7.2,4.78l1.03-1.71c0.39-0.65,1.33-0.65,1.72,0l1.48,2.46l-1.23,2.06L9.2,9.21L5.77,7.15z M21.72,12.97 l-1.6-2.66l-3.46,2L18.87,16H20c0.76,0,1.45-0.43,1.79-1.11C21.93,14.61,22,14.31,22,14C22,13.64,21.9,13.29,21.72,12.97z M16,21 h1.5c0.76,0,1.45-0.43,1.79-1.11L20.74,17H16v-2l-4,4l4,4V21z M10,17H5.7l-0.84,1.41c-0.3,0.5-0.32,1.12-0.06,1.65l0,0 C5.08,20.63,5.67,21,6.32,21H10V17z M6.12,14.35l1.73,1.04L6.48,9.9L1,11.27l1.7,1.02l-0.41,0.69c-0.35,0.59-0.38,1.31-0.07,1.92 l1.63,3.26L6.12,14.35z M17.02,5.14l-1.3-2.17C15.35,2.37,14.7,2,14,2h-3.53l3.12,5.2l-1.72,1.03l5.49,1.37l1.37-5.49L17.02,5.14z' />
);

export default function PickupList({
  addressData,
  garbageDay,
  yardDay,
  recyclingDay,
  brushDay,
  councilDistrict,
  superDistrict,
  fireDistrict,
}) {
  return (
    <>
      <Grid
        container
        direction='row'
        justifyContent='start'
        alignItems='space-between'
      >
        <ServiceBox
          icon={AddressIcon}
          label='Address'
          data={addressData?.address}
        />
        <ServiceBox
          icon={GarbageIcon}
          label='Garbage'
          data={garbageDay?.attributes?.PickUpDay}
        />
        <ServiceBox
          icon={YardIcon}
          label='Yard Waste'
          data={yardDay?.attributes?.PickUpDay}
        />
        <ServiceBox
          icon={RecyclingIcon}
          // icon={<SvgIcon></SvgIcon>}
          label='Recycling'
          data={recyclingDay?.attributes?.PickUpDay}
          link={recyclingDay?.attributes?.Link}
          buttonLabel='Calendar'
        />
        <ServiceBox
          icon={BrushIcon}
          label='Tree Limb'
          data={brushDay?.attributes?.ROUTE}
          link={brushDay?.attributes?.Link}
          buttonLabel='Calendar'
        />
        <ServiceBox
          icon={CouncilIcon}
          label='Council District'
          data={councilDistrict?.attributes?.District}
          link={councilDistrict?.attributes?.Link}
        />
        <ServiceBox
          icon={SuperIcon}
          label='Super District'
          data={superDistrict?.attributes?.District}
          link={superDistrict?.attributes?.Link}
        />
        <ServiceBox
          icon={FireIcon}
          label='Fire District'
          data={fireDistrict?.attributes?.DIST_ID}
        />
      </Grid>
    </>
  );
}
